import store from '@/store'
export default [
  {
    path: '/departments',
    name: 'department',
    meta: { requiresAuth: true },
    component: () => import('@/pages/department/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('department/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/departments/:id',
    name: 'department-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/department/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('department/dataBeforeCreate')
      let response = await store.dispatch('department/find', to.params.id)
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
